<template>
  <div class="gp-main-body-content">
    <NoticeBanner
      v-if="showBFCMNoticeBanner && isBFCM && !bfcmBannerClosed"
      @close="closeBFCMBanner"
      @onclick="redirectToPricing"
      title="dataNewPlan.promotion.notice.title"
      description="dataNewPlan.promotion.notice.desc"
      submit-text="dataNewPlan.promotion.notice.button"
      learn-more-text="dataNewPlan.promotion.notice.learnMore"
      learn-more-url="dataNewPlan.promotion.notice.learnMoreLink"
    />
    <DiscountBanner v-if="shopInfo.emailDiscountCode" :email="shopInfo.emailDiscountCode" />
    <ChrismastBanner v-else-if="shopInfo.christmasDiscount" />
    <header class="d-flex justify-content-between dashboard__header">
      <div v-if="firstName.length">
        <!-- Hello, {firstName}! -->
        <h2 class="heading-h2-24-semi text-light-high dashboard__hello">{{ helloMessage }}</h2>

        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="paragraph-14-regular text-dark6">
            <!-- Time to take store design and conversions to the next level! -->
            {{ helloMessageDesc }}
          </span>
        </div>
      </div>
      <div v-if="isGemPagesV7" class="d-flex align-items-end">
        <div class="ml-1 dashboard__create border-radius d-flex align-items-center" @mouseleave="closeModal" @mouseover="openCreateModal" :class="{ active: createModalActive }">
          <div class="d-flex align-items-center dashboard__create-content px-2 no-border clickable" ref="createButton">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.1252 1.94922C11.1252 1.60404 10.8454 1.32422 10.5002 1.32422C10.1551 1.32422 9.87524 1.60404 9.87524 1.94922V9.37524H2.44922C2.10404 9.37524 1.82422 9.65507 1.82422 10.0002C1.82422 10.3454 2.10404 10.6252 2.44922 10.6252H9.87524V18.0512C9.87524 18.3964 10.1551 18.6762 10.5002 18.6762C10.8454 18.6762 11.1252 18.3964 11.1252 18.0512V10.6252H18.5512C18.8964 10.6252 19.1762 10.3454 19.1762 10.0002C19.1762 9.65507 18.8964 9.37524 18.5512 9.37524H11.1252V1.94922Z" fill="white" />
            </svg>
            <span class="dashboard__create-txt px-1 paragraph-14-16-medium text-light1">{{ createNewTxt }}</span>

            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.63313 7.62204C5.81064 7.45932 6.09845 7.45932 6.27596 7.62204L10.5 11.4941L14.724 7.62204C14.9016 7.45932 15.1894 7.45932 15.3669 7.62204C15.5444 7.78476 15.5444 8.04858 15.3669 8.21129L10.8214 12.378C10.6439 12.5407 10.3561 12.5407 10.1786 12.378L5.63313 8.21129C5.45562 8.04858 5.45562 7.78476 5.63313 7.62204Z" fill="white" />
            </svg>
          </div>

          <div class="dropdown pt-4px" v-if="createModalActive" ref="createModal" v-clickaway="closeCreateModal">
            <div class="bg-light1 border-radius">
              <a @click.stop @click.prevent="onCreateNewPage('subpages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.625 3.125C3.625 2.08947 4.46447 1.25 5.5 1.25H12.6998C13.2288 1.25 13.7332 1.47346 14.0886 1.86528L16.8888 4.95237C17.2017 5.29732 17.375 5.74637 17.375 6.21208V16.875C17.375 17.9105 16.5355 18.75 15.5 18.75H5.5C4.46447 18.75 3.625 17.9105 3.625 16.875V3.125ZM5.5 2.5C5.15482 2.5 4.875 2.77982 4.875 3.125V13.3589H16.125V6.5H12.9651C12.6199 6.5 12.3401 6.22018 12.3401 5.875V2.5H5.5ZM13.5901 3.17621V5.25H15.4711L13.5901 3.17621ZM4.875 16.875V14.6089H16.125V16.875C16.125 17.2202 15.8452 17.5 15.5 17.5H5.5C5.15482 17.5 4.875 17.2202 4.875 16.875Z" fill="#676767" />
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name">{{ createPageLabel.landingPages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('homepages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0729 1.40354C10.8334 1.18254 10.4644 1.18254 10.225 1.40354L2.1 8.90354C1.84637 9.13767 1.83055 9.53308 2.06468 9.78672C2.2988 10.0404 2.69422 10.0562 2.94785 9.82204L3.87525 8.96599V16.5277C3.87525 17.5632 4.71471 18.4027 5.75025 18.4027H15.5002C16.5358 18.4027 17.3752 17.5632 17.3752 16.5277V8.92227L18.35 9.82204C18.6036 10.0562 18.9991 10.0404 19.2332 9.78672C19.4673 9.53308 19.4515 9.13767 19.1979 8.90354L11.0729 1.40354ZM16.1257 7.76885L10.6489 2.71336L5.12525 7.81214V16.5277C5.12525 16.8729 5.40507 17.1527 5.75025 17.1527H7.47559L7.47559 13.5278C7.47559 12.4923 8.31506 11.6528 9.35059 11.6528H11.8506C12.8861 11.6528 13.7256 12.4923 13.7256 13.5278V17.1527H15.5002C15.8454 17.1527 16.1252 16.8729 16.1252 16.5277V7.79297C16.1252 7.78489 16.1254 7.77685 16.1257 7.76885ZM12.4756 17.1527H8.72559L8.72559 13.5278C8.72559 13.1827 9.00541 12.9028 9.35059 12.9028H11.8506C12.1958 12.9028 12.4756 13.1827 12.4756 13.5278V17.1527Z" fill="#676767" />
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name">{{ createPageLabel.homePages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('productpages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.4651 11.3914C11.5045 11.3914 12.3261 11.0913 12.9595 10.6148C13.5849 10.1443 13.9928 9.52815 14.2593 8.94157C14.5257 8.35525 14.6608 7.77709 14.7301 7.35109C14.765 7.13655 14.7839 6.9566 14.7941 6.82816C14.7998 6.75662 14.8044 6.68489 14.806 6.61313L14.8061 6.6108C14.7301 5.88847 13.6353 5.78092 13.5563 6.58866C13.4772 7.39639 13.5562 6.59228 13.5562 6.59228C13.5562 6.59228 13.5559 6.59559 13.5553 6.6027C13.5501 6.66446 13.5233 6.98483 13.4963 7.15036C13.4385 7.50562 13.3282 7.96913 13.1213 8.42449C12.9145 8.87958 12.6213 9.30506 12.2081 9.61587C11.803 9.92061 11.2485 10.1414 10.4651 10.1414C9.68162 10.1414 9.13311 9.92067 8.73611 9.6182C8.33089 9.30946 8.04614 8.88641 7.84758 8.43254C7.64887 7.97836 7.54646 7.51565 7.49467 7.16057C7.46901 6.98463 7.45636 6.83915 7.45015 6.73977C7.44723 6.693 7.44489 6.6461 7.44425 6.59924C7.45836 5.75482 6.22304 5.75018 6.19425 6.60099C6.1944 6.65923 6.19625 6.71643 6.20259 6.81775C6.21062 6.94623 6.22645 7.12627 6.25776 7.34096C6.31991 7.76712 6.44536 8.34608 6.70238 8.93356C6.95954 9.52136 7.35839 10.14 7.97856 10.6125C8.60695 11.0913 9.42563 11.3914 10.4651 11.3914Z" fill="#676767" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.62769 1.25C3.64057 1.25 2.82251 2.01534 2.75684 3.00028L1.84017 16.7503C1.76803 17.8325 2.6264 18.75 3.71102 18.75H17.2889C18.3735 18.75 19.2318 17.8325 19.1597 16.7503L18.243 3.00028C18.1774 2.01534 17.3593 1.25 16.3722 1.25H4.62769ZM4.00408 3.08343C4.02596 2.75511 4.29865 2.5 4.62769 2.5H16.3722C16.7012 2.5 16.9739 2.75511 16.9958 3.08343L17.9125 16.8334C17.9365 17.1942 17.6504 17.5 17.2889 17.5H3.71102C3.34948 17.5 3.06336 17.1942 3.08741 16.8334L4.00408 3.08343Z" fill="#676767" />
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name">{{ createPageLabel.productPages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('collectionpages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.375 3.375C2.375 2.54657 3.04657 1.875 3.875 1.875H8.1875C9.01593 1.875 9.6875 2.54657 9.6875 3.375V7.6875C9.6875 8.51593 9.01593 9.1875 8.1875 9.1875H3.875C3.04657 9.1875 2.375 8.51593 2.375 7.6875V3.375ZM3.875 3.125H8.1875C8.32557 3.125 8.4375 3.23693 8.4375 3.375V7.6875C8.4375 7.82557 8.32557 7.9375 8.1875 7.9375H3.875C3.73693 7.9375 3.625 7.82557 3.625 7.6875V3.375C3.625 3.23693 3.73693 3.125 3.875 3.125Z" fill="#676767" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.375 12.3127C2.375 11.4843 3.04657 10.8127 3.875 10.8127H8.1875C9.01593 10.8127 9.6875 11.4843 9.6875 12.3127V16.6252C9.6875 17.4537 9.01593 18.1252 8.1875 18.1252H3.875C3.04657 18.1252 2.375 17.4537 2.375 16.6252V12.3127ZM3.875 12.0627H8.1875C8.32557 12.0627 8.4375 12.1747 8.4375 12.3127V16.6252C8.4375 16.7633 8.32557 16.8752 8.1875 16.8752H3.875C3.73693 16.8752 3.625 16.7633 3.625 16.6252V12.3127C3.625 12.1747 3.73693 12.0627 3.875 12.0627Z" fill="#676767" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8125 1.875C11.9841 1.875 11.3125 2.54657 11.3125 3.375V7.6875C11.3125 8.51593 11.9841 9.1875 12.8125 9.1875H17.125C17.9534 9.1875 18.625 8.51593 18.625 7.6875V3.375C18.625 2.54657 17.9534 1.875 17.125 1.875H12.8125ZM17.125 3.125H12.8125C12.6744 3.125 12.5625 3.23693 12.5625 3.375V7.6875C12.5625 7.82557 12.6744 7.9375 12.8125 7.9375H17.125C17.2631 7.9375 17.375 7.82557 17.375 7.6875V3.375C17.375 3.23693 17.2631 3.125 17.125 3.125Z" fill="#676767" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3125 12.3127C11.3125 11.4843 11.9841 10.8127 12.8125 10.8127H17.125C17.9534 10.8127 18.625 11.4843 18.625 12.3127V16.6252C18.625 17.4537 17.9534 18.1252 17.125 18.1252H12.8125C11.9841 18.1252 11.3125 17.4537 11.3125 16.6252V12.3127ZM12.8125 12.0627H17.125C17.2631 12.0627 17.375 12.1747 17.375 12.3127V16.6252C17.375 16.7633 17.2631 16.8752 17.125 16.8752H12.8125C12.6744 16.8752 12.5625 16.7633 12.5625 16.6252V12.3127C12.5625 12.1747 12.6744 12.0627 12.8125 12.0627Z" fill="#676767" />
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name" :style="disableStarter">{{ createPageLabel.collectionPages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('articlepages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6664 1.93152C16.0318 1.29692 15.0029 1.29691 14.3683 1.93152L2.78644 13.5134C2.50307 13.7967 2.33441 14.1748 2.31284 14.575L2.17452 17.1415C2.13851 17.8097 2.69022 18.3614 3.35842 18.3254L5.925 18.1872C6.32517 18.1656 6.70325 17.9969 6.98662 17.7136L18.5685 6.1317C19.2031 5.49709 19.2031 4.4682 18.5685 3.8336L16.6664 1.93152ZM15.2522 2.8154C15.3986 2.66896 15.6361 2.66895 15.7825 2.8154L17.6846 4.71748C17.831 4.86393 17.831 5.10137 17.6846 5.24781L15.453 7.47944L13.0206 5.04703L15.2522 2.8154ZM11.9599 6.10769L3.67032 14.3973C3.60493 14.4627 3.566 14.5499 3.56103 14.6423L3.4302 17.0698L5.85775 16.939C5.95009 16.934 6.03734 16.8951 6.10274 16.8297L14.3923 8.5401L11.9599 6.10769Z" fill="#676767" />
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name" :style="disableStarter">{{ createPageLabel.articlePages.text }}</span>
                </div>
              </a>
              <!-- <div class="px-2 py-10px power-by d-flex align-items-center justify-content-between dropdown__item">
                <span>Powered by</span>
                <svg width="48" height="18" viewBox="0 0 48 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.2484 7.05966C7.17738 6.82955 7.07937 6.62358 6.95437 6.44176C6.83221 6.2571 6.68448 6.09943 6.51119 5.96875C6.34073 5.83807 6.14471 5.74006 5.92312 5.67472C5.70153 5.60653 5.46005 5.57244 5.19869 5.57244C4.72994 5.57244 4.31232 5.69034 3.94585 5.92614C3.57937 6.16193 3.29102 6.50852 3.08079 6.96591C2.8734 7.42045 2.76971 7.97443 2.76971 8.62784C2.76971 9.28693 2.8734 9.84517 3.08079 10.3026C3.28817 10.7599 3.57653 11.108 3.94585 11.3466C4.31516 11.5824 4.74414 11.7003 5.23278 11.7003C5.67596 11.7003 6.05948 11.6151 6.38335 11.4446C6.71005 11.2741 6.96147 11.0327 7.13761 10.7202C7.31374 10.4048 7.40181 10.0355 7.40181 9.61222L7.75977 9.66761H5.39045V8.43182H8.93164V9.48011C8.93164 10.2273 8.77255 10.8736 8.45437 11.419C8.13619 11.9645 7.69869 12.3849 7.14187 12.6804C6.58505 12.973 5.94585 13.1193 5.22425 13.1193C4.42028 13.1193 3.71431 12.9389 3.10636 12.5781C2.50124 12.2145 2.02823 11.6989 1.68732 11.0312C1.34925 10.3608 1.18022 9.56534 1.18022 8.64489C1.18022 7.94034 1.27965 7.31108 1.47852 6.7571C1.68022 6.20312 1.96147 5.73295 2.32227 5.34659C2.68306 4.95739 3.10636 4.66193 3.59215 4.46023C4.07795 4.25568 4.60636 4.15341 5.17738 4.15341C5.66033 4.15341 6.11062 4.22443 6.52823 4.36648C6.94585 4.50568 7.31658 4.70455 7.64045 4.96307C7.96715 5.22159 8.23562 5.52841 8.44585 5.88352C8.65607 6.23864 8.79386 6.63068 8.8592 7.05966H7.2484ZM13.29 13.1278C12.6337 13.1278 12.0669 12.9915 11.5897 12.7188C11.1152 12.4432 10.7502 12.054 10.4945 11.5511C10.2388 11.0455 10.111 10.4503 10.111 9.76562C10.111 9.09233 10.2388 8.50142 10.4945 7.9929C10.753 7.48153 11.1138 7.08381 11.5769 6.79972C12.04 6.51278 12.584 6.36932 13.209 6.36932C13.6124 6.36932 13.9931 6.43466 14.351 6.56534C14.7118 6.69318 15.03 6.89205 15.3056 7.16193C15.584 7.43182 15.8027 7.77557 15.9618 8.19318C16.1209 8.60795 16.2005 9.10227 16.2005 9.67614V10.1491H10.8354V9.10938H14.7218C14.7189 8.81392 14.655 8.55114 14.53 8.32102C14.405 8.08807 14.2303 7.90483 14.0059 7.77131C13.7843 7.63778 13.5257 7.57102 13.2303 7.57102C12.915 7.57102 12.638 7.64773 12.3993 7.80114C12.1607 7.9517 11.9746 8.15057 11.8411 8.39773C11.7104 8.64205 11.6436 8.91051 11.6408 9.20312V10.1108C11.6408 10.4915 11.7104 10.8182 11.8496 11.0909C11.9888 11.3608 12.1834 11.5682 12.4334 11.7131C12.6834 11.8551 12.976 11.9261 13.3113 11.9261C13.5357 11.9261 13.7388 11.8949 13.9206 11.8324C14.1025 11.767 14.2601 11.6719 14.3936 11.5469C14.5272 11.4219 14.628 11.267 14.6962 11.0824L16.1365 11.2443C16.0456 11.625 15.8723 11.9574 15.6167 12.2415C15.3638 12.5227 15.04 12.7415 14.6451 12.8977C14.2502 13.0511 13.7985 13.1278 13.29 13.1278ZM17.5055 13V6.45455H18.9799V7.56676H19.0566C19.193 7.19176 19.4189 6.89915 19.7342 6.68892C20.0495 6.47585 20.426 6.36932 20.8635 6.36932C21.3066 6.36932 21.6802 6.47727 21.9842 6.69318C22.291 6.90625 22.5069 7.19744 22.6319 7.56676H22.7001C22.845 7.20312 23.0893 6.91335 23.4331 6.69744C23.7797 6.47869 24.1902 6.36932 24.6646 6.36932C25.2669 6.36932 25.7583 6.55966 26.139 6.94034C26.5197 7.32102 26.7101 7.87642 26.7101 8.60653V13H25.1632V8.84517C25.1632 8.43892 25.0552 8.14205 24.8393 7.95455C24.6234 7.7642 24.3592 7.66903 24.0467 7.66903C23.6745 7.66903 23.3833 7.78551 23.1731 8.01847C22.9657 8.24858 22.862 8.5483 22.862 8.91761V13H21.3493V8.78125C21.3493 8.44318 21.247 8.1733 21.0424 7.97159C20.8407 7.76989 20.5765 7.66903 20.2498 7.66903C20.0282 7.66903 19.8265 7.72585 19.6447 7.83949C19.4629 7.95028 19.318 8.10795 19.21 8.3125C19.1021 8.5142 19.0481 8.75 19.0481 9.01989V13H17.5055ZM29.464 13H27.7765L30.8489 4.27273H32.8006L35.8773 13H34.1898L31.8588 6.0625H31.7907L29.464 13ZM29.5194 9.57812H34.1216V10.848H29.5194V9.57812ZM38.6078 4.27273V13H37.0268V4.27273H38.6078Z" fill="url(#paint0_linear_1951_78714)" />
                  <path d="M43.261 1.0282C43.3333 0.792683 43.6667 0.792683 43.739 1.0282L44.2182 2.58942C44.3113 2.89264 44.5427 3.13372 44.8418 3.23913L46.3308 3.76382C46.5534 3.84224 46.5534 4.15698 46.3308 4.2354L44.8418 4.76008C44.5427 4.86549 44.3113 5.10658 44.2182 5.4098L43.739 6.97101C43.6667 7.20653 43.3333 7.20653 43.261 6.97101L42.7817 5.4098C42.6887 5.10658 42.4573 4.86549 42.1581 4.76008L40.6691 4.2354C40.4466 4.15698 40.4466 3.84224 40.6691 3.76382L42.1581 3.23913C42.4573 3.13372 42.6887 2.89264 42.7817 2.58942L43.261 1.0282Z" fill="url(#paint1_linear_1951_78714)" />
                  <defs>
                    <linearGradient id="paint0_linear_1951_78714" x1="39.5" y1="13.7432" x2="0.499335" y2="13.6469" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#874CFD" />
                      <stop offset="1" stop-color="#3C38E1" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_1951_78714" x1="45.6048" y1="2.62234" x2="41.2264" y2="2.92341" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#3C67FF" />
                      <stop offset="1" stop-color="#874CFD" />
                    </linearGradient>
                  </defs>
                </svg>
              </div> -->
              <!-- <hr class="bg-light3" />
        <div class="px-2 py-12px d-flex align-items-center justify-content-between dropdown__item" @click="toggleMoreTypes">
          <div class="d-flex align-items-center justify-content-between">
            <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="3" cy="8.00012" r="1" fill="#1E232F" />
              <circle cx="8" cy="8.00012" r="1" fill="#1E232F" />
              <circle cx="13" cy="8.00012" r="1" fill="#1E232F" />
            </svg>
            <span class="ml-1 paragraph-14-16-medium name">{{ moreCreateTypeTxt }}</span>
          </div>
          <i class="icon" :class="showCreateMoreTypes ? 'icon-arrow-up' : 'icon-arrow-down'"></i>
        </div> -->
            </div>
          </div>
        </div>
      </div>
      <div v-else class="d-flex align-items-end">
        <!-- Pending: Move Widget on Page -->
        <!-- <div class="border-radius bg-primary-300 py-1 px-2 mr-3 clickable" v-if="openCustom">
          <span class="paragraph-14-medium text-light1">Add Widget</span>
        </div> -->

        <div class="border-radius d-flex justify-content-center align-items-center clickable dashboard__custome-icon" v-popover:tooltip.top="'Customize Dashboard'" @click="showCustom">
          <i class="icon icon-customize text-light-high"></i>
        </div>

        <div class="ml-1 dashboard__create border-radius d-flex align-items-center" :class="{ active: createModalActive }">
          <div class="d-flex align-items-center dashboard__create-content px-3 no-border clickable" @click="toggleCreateModal" ref="createButton">
            <i class="icon icon-new-plus dashboard__create-icon mr-1 text-light1"></i>
            <span class="dashboard__create-txt paragraph-14-16-medium text-light1">{{ createNewTxt }}</span>
            <i class="icon icon-new-arrow-down dashboard__create-icon ml-1 text-light1"></i>
          </div>

          <div class="dropdown mt-4px w-dropdown-v6" v-if="createModalActive" ref="createModal" v-clickaway="closeCreateModal">
            <div class="bg-light1 border-radius">
              <a @click.stop @click.prevent="onCreateNewPage('subpages')" class="px-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5111 0.666626H3.33333C2.59695 0.666626 2 1.26358 2 1.99996V14C2 14.7363 2.59695 15.3333 3.33333 15.3333H12.6667C13.403 15.3333 14 14.7363 14 14V3.915C14 3.53402 13.837 3.17124 13.5522 2.91821L11.3966 1.00317C11.1526 0.786373 10.8375 0.666626 10.5111 0.666626ZM3.33333 11.3333V1.99996H9.33333V5.36666C9.33333 5.73485 9.63181 6.03332 10 6.03332H11.658C12.0262 6.03332 12.3247 5.73485 12.3247 5.36666C12.3247 4.99847 12.0262 4.69999 11.658 4.69999H10.6667V2.13819L12.6667 3.915V11.3333H3.33333ZM3.33333 12.6666V14H12.6667V12.6666H3.33333Z" fill="#1E232F" />
                  </svg>
                  <span class="ml-1 paragraph-14-16-medium name">{{ createPageLabel.landingPages.text }}</span>
                </div>
                <p class="body-12-regular text-dark-subtext2">{{ createPageLabel.landingPages.number }}</p>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('homepages')" class="px-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg class="icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.50137 9.75H3.00109V15.75C3.00109 16.1642 3.33682 16.5 3.75096 16.5H8.24759L8.25 16.5H9.75L9.75242 16.5H14.249C14.6632 16.5 14.9989 16.1642 14.9989 15.75V9.75H16.4986C17.1667 9.75 17.5013 8.94214 17.0289 8.46967L9.53023 0.96967C9.23739 0.676777 8.76261 0.676777 8.46977 0.96967L0.971133 8.46967C0.498746 8.94214 0.83331 9.75 1.50137 9.75ZM13.5 15L11.25 15V10.5C11.25 9.67157 10.5784 9 9.75 9H8.25C7.42158 9 6.75 9.67157 6.75 10.5V15L4.5 15V9C4.5 8.58578 4.16422 8.25 3.75 8.25H3.31066L9 2.56066L14.6893 8.25H14.25C13.8358 8.25 13.5 8.58578 13.5 9V15ZM8.25 15V10.5H9.75V15H8.25Z" fill="#1E232F" />
                  </svg>

                  <span class="ml-1 paragraph-14-16-medium name">{{ createPageLabel.homePages.text }}</span>
                </div>
                <p class="body-12-regular text-dark-subtext2">{{ createPageLabel.homePages.number }}</p>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('productpages')" class="px-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="disableStarter" fill-rule="evenodd" clip-rule="evenodd" d="M13.0182 1.3335C13.5489 1.3335 13.9872 1.74811 14.0166 2.27803L14.6267 13.2595C14.6676 13.9948 14.1047 14.6239 13.3694 14.6648C13.3325 14.6665 13.3325 14.6665 13.2955 14.6668H13.2955H13.2955H2.70492C1.96854 14.6668 1.37158 14.0699 1.37158 13.3335C1.37175 13.315 1.37184 13.3057 1.3721 13.2965C1.37235 13.2873 1.37278 13.278 1.37363 13.2595L1.98372 2.27803C2.01316 1.74811 2.45145 1.3335 2.98218 1.3335H13.0182ZM3.29751 2.66683L2.70492 13.3335H13.2955L12.7029 2.66683H3.29751ZM5.33352 4.00016C4.96533 4.00016 4.66685 4.29864 4.66685 4.66683V5.66683C4.66685 7.26729 6.21568 8.66683 8.00019 8.66683C9.7847 8.66683 11.3335 7.26729 11.3335 5.66683V4.66683C11.3335 4.29864 11.035 4.00016 10.6669 4.00016C10.2987 4.00016 10.0002 4.29864 10.0002 4.66683V5.66683C10.0002 6.49908 9.07676 7.3335 8.00019 7.3335C6.92361 7.3335 6.00019 6.49908 6.00019 5.66683V4.66683C6.00019 4.29864 5.70171 4.00016 5.33352 4.00016Z" fill="#1E232F" />
                  </svg>

                  <span class="ml-1 paragraph-14-16-medium name">{{ createPageLabel.productPages.text }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <p class="body-12-regular text-dark-subtext2">{{ createPageLabel.productPages.number }}</p>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('collectionpages')" class="px-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg class="icon" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="disableStarter" fill-rule="evenodd" clip-rule="evenodd" d="M2.87507 3.925V7.86175H6.81244V3.925H2.87507ZM2.27207 2.422C1.77501 2.422 1.37207 2.82494 1.37207 3.322V8.46475C1.37207 8.9618 1.77501 9.36475 2.27207 9.36475H7.41544C7.91249 9.36475 8.31544 8.96181 8.31544 8.46475V3.322C8.31544 2.82494 7.91249 2.422 7.41544 2.422H2.27207Z" fill="#1E232F" />
                    <path :style="disableStarter" fill-rule="evenodd" clip-rule="evenodd" d="M2.87507 11.9785V15.9152H6.81244V11.9785H2.87507ZM2.27207 10.4755C1.77501 10.4755 1.37207 10.8784 1.37207 11.3755V16.5182C1.37207 17.0153 1.77501 17.4182 2.27207 17.4182H7.41544C7.9125 17.4182 8.31544 17.0153 8.31544 16.5182V11.3755C8.31544 10.8784 7.9125 10.4755 7.41544 10.4755H2.27207Z" fill="#1E232F" />
                    <path :style="disableStarter" fill-rule="evenodd" clip-rule="evenodd" d="M11.1876 3.925V7.86175H15.1249V3.925H11.1876ZM10.5846 2.422C10.0875 2.422 9.68457 2.82494 9.68457 3.322V8.46475C9.68457 8.9618 10.0875 9.36475 10.5846 9.36475H15.7279C16.225 9.36475 16.6279 8.9618 16.6279 8.46475V3.322C16.6279 2.82494 16.225 2.422 15.7279 2.422H10.5846Z" fill="#1E232F" />
                    <path :style="disableStarter" fill-rule="evenodd" clip-rule="evenodd" d="M11.1876 11.9785V15.9152H15.1249V11.9785H11.1876ZM10.5846 10.4755C10.0875 10.4755 9.68457 10.8784 9.68457 11.3755V16.5182C9.68457 17.0153 10.0875 17.4182 10.5846 17.4182H15.7279C16.225 17.4182 16.6279 17.0153 16.6279 16.5182V11.3755C16.6279 10.8784 16.225 10.4755 15.7279 10.4755H10.5846Z" fill="#1E232F" />
                  </svg>

                  <span class="ml-1 paragraph-14-16-medium name" :style="disableStarter">{{ createPageLabel.collectionPages.text }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <p class="body-12-regular text-dark-subtext2" :style="disableStarter">{{ createPageLabel.collectionPages.number }}</p>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('articlepages')" class="px-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg :style="disableStarter" class="icon" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="disableStarter" fill-rule="evenodd" clip-rule="evenodd" d="M12.728 1.86298L14.6136 3.74859C15.1343 4.26929 15.1343 5.11351 14.6136 5.63421L5.6569 14.5909C5.40685 14.8409 5.06771 14.9814 4.71409 14.9814L2.82847 14.9814C2.09209 14.9814 1.49514 14.3845 1.49514 13.6481L1.49514 11.7625C1.49514 11.4088 1.63561 11.0697 1.88566 10.8197L10.8423 1.86298C11.363 1.34228 12.2073 1.34228 12.728 1.86298ZM9.69734 4.8936L2.82847 11.7625L2.82847 13.6481L4.71409 13.6481L11.583 6.77922L9.69734 4.8936ZM10.6401 3.95079L12.5258 5.83641L13.6708 4.6914L11.7852 2.80578L10.6401 3.95079Z" fill="#1E232F" />
                  </svg>

                  <span class="ml-1 paragraph-14-16-medium name" :style="disableStarter">{{ createPageLabel.articlePages.text }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <p class="body-12-regular text-dark-subtext2" :style="disableStarter">{{ createPageLabel.articlePages.number }}</p>
                </div>
              </a>
              <!-- <hr class="bg-light3" />
              <div class="px-2 py-12px d-flex align-items-center justify-content-between dropdown__item" @click="toggleMoreTypes">
                <div class="d-flex align-items-center justify-content-between">
                  <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="3" cy="8.00012" r="1" fill="#1E232F" />
                    <circle cx="8" cy="8.00012" r="1" fill="#1E232F" />
                    <circle cx="13" cy="8.00012" r="1" fill="#1E232F" />
                  </svg>
                  <span class="ml-1 paragraph-14-16-medium name">{{ moreCreateTypeTxt }}</span>
                </div>
                <i class="icon" :class="showCreateMoreTypes ? 'icon-arrow-up' : 'icon-arrow-down'"></i>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="container mt-3">
      <div class="row">
        <div class="col-8 pl-0">
          <StoreOnlineThemeChange :theme-name="shopifyDefaultTheme.name" @close="closePanelThemeChange" v-if="isShowPanelThemeChange" />
          <TrialTooltipPlanVue />
          <GemAIBanner :isShowPlaceHolder="isSessionHasShowPanelThemeChange === undefined" v-if="isShowGemAIBanner" />
          <template v-if="leftSections.filter(item => item.show).length">
            <ExpiredTrial />
            <components v-for="(item, index) in displayedLeftSections" :key="index" :is="getComponent(item.name)" />
          </template>
          <template v-else>
            <SectionPlaceholder side="left" @add-widget="showCustom" />
            <ExpiredTrial />
          </template>
        </div>
        <div class="col-4 pr-0">
          <!-- Pending: Move Widget on Page -->
          <!-- <div class="d-flex justify-content-center align-items-center dashboard__placeholder" v-if="openCustom">
            <span class="body-14-regular txt-dark-disabled text-center text__right"> When you add a new small widget, it will appear here </span>
          </div> -->
          <!-- <Community></Community> -->
          <SurveyOnboard></SurveyOnboard>
          <template v-if="rightSections.filter(item => item.show).length">
            <components v-for="(item, index) in rightSections.filter(item => item.show)" :key="index" :is="getComponent(item.name)" />
          </template>
          <template v-else>
            <SectionPlaceholder side="right" @add-widget="showCustom" />
          </template>
        </div>
      </div>
    </div>

    <Modal v-if="openCustom" :active="openCustom" mClass="p-0 border-radius custom" padding="p-0" @cancel="closeCustom" @container="closeCustom">
      <template #default>
        <div class="custom__modal">
          <!-- Header -->
          <div class="custom__modal-header d-flex align-items-center bg-light1 px-4 position-relative">
            <p class="text-lightmode heading-h3-20-medium mr-4px">{{ $t("dashboard.customTitle") }}</p>
            <div class="gp_modal-close p-1" @click="closeCustom"><i class="text-light-high icon icon-cancel"></i></div>
          </div>
          <div class="custom__container" ref="customContainer">
            <!-- Main -->
            <div class="bg-light1 p-4 pt-3" @mousemove="dragFunction">
              <div class="p-2 custom__tips bg-info d-flex align-items-center justify-content-between border-radius mb-3" v-if="showGotItCustom">
                <div class="d-flex align-items-center">
                  <i class="icon icon-infor-fill" />
                  <span class="ml-1 txt-dark-low-contrast body-14-regular">{{ $t("dashboard.customGotItText") }}</span>
                </div>
                <i class="icon icon-cancel" @click="clickGotIt" />
              </div>

              <div class="d-flex justify-content-between">
                <div class="custom__col">
                  <p class="text-dark-low body-12-regular custom__col-title">{{ $t("dashboard.leftSection") }}</p>

                  <div class="mt-2">
                    <div v-for="(item, i) in customLeftSections" :key="`left-${i}`" class="custom__item" :class="customItemDynamicClass(item, i)" ref="leftItems">
                      <div class="bg-light-grey-400 border-radius custom__placeholder" v-if="dragFrom && dragFrom.side == 'left' && dragFrom.i == i">&nbsp;</div>
                      <div class="bg-light1 border-radius custom__item-body" @mousedown="e => startDrag(item, i, e, 'left')">
                        <i class="icon icon-drag custom__drag-icon" />

                        <div class="d-flex align-items-center custom__item-body-content ml-2">
                          <i class="icon text-light-high" :class="customItemsMap[item.name].icon" />
                          <span class="ml-12px body-14-medium text-light-high">{{ customItemsMap[item.name].title }}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center custom__switch clickable" v-if="!(dragFrom && dragFrom.side == 'left' && dragFrom.i == i)" @click="e => toggleCustomItem(item, e)">
                        <Toggler v-model="item.show" small :disabled="item.disabled" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="custom__col">
                  <p class="text-dark-low body-12-regular custom__col-title">{{ $t("dashboard.rightSection") }}</p>
                  <div class="mt-2">
                    <div v-for="(item, i) in customRightSections" :key="`right-${i}`" class="border-radius custom__item" :class="customItemDynamicClass(item, i)" ref="rightItems">
                      <div class="bg-light-grey-400 border-radius custom__placeholder" v-if="dragFrom && dragFrom.side == 'right' && dragFrom.i == i">&nbsp;</div>
                      <div class="bg-light1 border-radius custom__item-body" @mousedown="e => startDrag(item, i, e, 'right')">
                        <i class="icon icon-drag custom__drag-icon" />

                        <div class="d-flex align-items-center custom__item-body-content ml-2">
                          <i class="icon text-light-high" :class="customItemsMap[item.name].icon" />
                          <span class="ml-12px body-14-medium text-light-high">{{ customItemsMap[item.name].title }}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center custom__switch clickable" v-if="!(dragFrom && dragFrom.side == 'right' && dragFrom.i == i)" @click="e => toggleCustomItem(item, e)">
                        <Toggler v-model="item.show" small :disabled="item.disabled" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="custom__modal-footer bg-light1 px-4 py-3 d-flex flex-row-reverse">
            <div :disabled="saveCustomStatus == 'disabled'" class="border-radius body-14-medium py-1 px-2 clickable ml-1 custom__save" :class="saveCustomDynamicClass" @click="clickSaveCustom" v-html="saveCustomText"></div>
            <div class="border-radius txt-dark-high-contrast d-flex align-items-center px-3 clickable custom__reset" @click="resetCustom">
              <p class="paragraph-14-16-medium">{{ $t("storeSettings.eventLogs.searchForm.reset") }}</p>
            </div>
          </div>
        </div>
        <div class="custom__drag" :style="dragDynamicStyle" v-if="dragRect" @mouseup="finishDrag" @mousemove="dragFunction">
          <div class="bg-light1 py-2 pr-2 pl-4 border-radius custom__drag-body">
            <i class="icon icon-drag custom__drag-icon" />
            <div class="d-flex justify-content-between align-items-center ml-1">
              <div class="d-flex align-items-center custom__drag-body-content">
                <icon class="icon" :class="customItemsMap[dragFrom.item.name].icon" />
                <span class="ml-12px body-14-medium txt-dark-high-contrast">{{ customItemsMap[dragFrom.item.name].title }}</span>
              </div>
              <div class="d-flex align-items-center">
                <Toggler v-model="dragFrom.item.show" small :disabled="dragFrom.item.disabled" />
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <SurveyReasonNotUpgrading />
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import { NotiBar, DiscountBanner, ChrismastBanner } from "@/core/components";
import RecentPage from "./RecentPage.vue";
import NewTemplate from "./NewTemplate.vue";
import SurveyOnboard from "./SurveyOnBoard/Index";
import SurveyReasonNotUpgrading from "./SurveyReasonNotUpgrading/Index";
import Community from "./Community.vue";
import Support from "./Support.vue";
import Banner from "./Banner.vue";
import Blog from "./Blog.vue";
import Faqs from "./Faqs.vue";
import TopIntegrations from "./TopIntegrations.vue";
import QuickStartGuide from "./QuickStartGuide.vue";
import ExpiredTrial from "./ExpiredTrial.vue";
import ChangeLog from "./ChangeLog.vue";
import SectionPlaceholder from "./SectionPlaceholder.vue";
import TrialTooltipPlanVue from "@/modules/Pricing/components/TrialTooltipPlan.vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { mutations } from "@/store/page/types";
import Cookie from "@/utils/cookie";
import { DASHBOARD_EVENT } from "@/config/constants/trackEventIds";
import dynamicTriggerContent from "@/mixins/dynamicTriggerContent";
import { createThemeAndPageV7 } from "@/modules/Instant/utils";
import initGemPagesV7 from "@/mixins/initGemPagesV7.js";
import StoreOnlineThemeChange from "./StoreOnlineThemeChange.vue";
import { getShopMetaByKey, META_KEY_GENERATOR_CONFIG, shopMetaCreateOrUpdateDocument } from "@/services/meta";
import { getShopifyDefaultTheme } from "@/services/global-style";
import GemAIBanner from "./GemAIBanner.vue";
import NoticeBanner from "@/modules/Dashboard/components/NoticeBanner.vue";
import planItem from "@/modules/Pricing/mixins/planItem";

const ComponentsMap = {
  recentPages: "RecentPage",
  newTemplates: "NewTemplate",
  support: "Support",
  banner: "Banner",
  blog: "Blog",
  faqs: "Faqs",
  topIntegrations: "TopIntegrations",
  changelog: "ChangeLog",
  quickStartGuide: "QuickStartGuide"
};

const cloneArray = array => {
  return JSON.parse(JSON.stringify(array));
};

const compareArray = (array1, array2) => {
  return JSON.stringify(array1) === JSON.stringify(array2);
};

export default {
  name: "NewDashboard",
  components: {
    NoticeBanner,
    NotiBar,
    RecentPage,
    NewTemplate,
    Support,
    Banner,
    Blog,
    Faqs,
    TopIntegrations,
    QuickStartGuide,
    ExpiredTrial,
    ChangeLog,
    SectionPlaceholder,
    DiscountBanner,
    ChrismastBanner,
    SurveyOnboard,
    SurveyReasonNotUpgrading,
    TrialTooltipPlanVue,
    Community,
    StoreOnlineThemeChange,
    GemAIBanner
  },
  mixins: [dynamicTriggerContent(), initGemPagesV7, planItem()],
  data: () => ({
    showCreateMoreTypes: false,
    dragRect: null,
    dragging: false,
    dragFrom: null,
    dragList: [],
    currentCustomLeftSections: [],
    currentCustomRightSections: [],
    saveCustomStatus: "disabled",
    showGotItCustom: false,
    createModalActive: false,
    isShowPanelThemeChange: false,
    isSessionHasShowPanelThemeChange: undefined,
    themeGSConfig: {},
    shopifyDefaultTheme: {
      name: ""
    },
    showBFCMNoticeBanner: true
  }),
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo",
      instantShopId: "instantShopId",
    }),
    ...mapState({
      permission: state => {
        return state.account.permissions;
      }
    }),
    ...mapGetters("account", {
      shopPlan: "shopPlan",
      firstName: "accountFirstName",
      shopifyDomain: "shopifyDomain",
      displayLanguage: "displayLanguage"
    }),
    ...mapGetters("dashboard", {
      leftSections: "leftSections",
      rightSections: "rightSections",
      openCustom: "openCustom",
      loadingDashboard: "loading",
      firstCallGetApi: "firstCallGetApi",
      bfcmBannerClosed: "bfcmBannerClosed"
    }),
    starterPlan() {
      return this.shopPlan === "starter";
    },
    disableEventStarter() {
      // if (this.shopPlan === "starter") {
      //   return {
      //     "pointer-events": "none"
      //   }
      // }

      return {};
    },
    disableStarter() {
      return {};
    },
    helloMessageDesc() {
      return this.$t("dashboard.helloMessageDesc");
    },
    createNewTxt() {
      return this.$t("dashboard.createNewPageTxt");
    },
    moreCreateTypeTxt() {
      return this.showCreateMoreTypes ? this.$t("dashboard.lessTypes") : this.$t("dashboard.moreTypes");
    },
    helloMessage() {
      return this.$t("dashboard.helloMessage", { name: this.firstName });
    },
    dragDynamicStyle() {
      let style = {};
      if (this.dragRect) {
        style.top = `${this.dragRect.top}px`;
        style.left = `${this.dragRect.left}px`;
        style.width = `${this.dragRect.width}px`;
        style.height = `${this.dragRect.height}px`;
      }

      return style;
    },

    isShowGemAIBanner() {
      const otherBanner = this.displayedLeftSections.filter(item => item.show).find(item => item.name === "banner");
      return this.isGemPagesV7 && !otherBanner && !this.isSessionHasShowPanelThemeChange;
    },

    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.isGemPagesV7) || window.___gemShopInfo.isGemPagesV7 || false;
    },
    displayedLeftSections() {
      if (this.isGemPagesV7) {
        return this.leftSections.filter(item => item.show && item.name !== "quickStartGuide");
      }
      return this.leftSections.filter(item => item.show);
    },
    customLeftSections() {
      if (this.dragging && this.dragFrom.side == "left") {
        return this.dragList;
      }

      if (this.isGemPagesV7) {
        return this.currentCustomLeftSections.filter(section => section.name !== "quickStartGuide");
      }
      return this.currentCustomLeftSections;
    },
    customRightSections() {
      if (this.dragging && this.dragFrom.side == "right") {
        return this.dragList;
      }
      return this.currentCustomRightSections;
    },
    customItemsMap() {
      return {
        recentPages: {
          title: this.$t("dashboard.recentPages"),
          icon: "icon-recent"
        },
        newTemplates: {
          title: this.$t("dashboard.newTemplates"),
          icon: "icon-new-template"
        },
        support: {
          title: this.$t("dashboard.support"),
          icon: "icon-help"
        },
        banner: {
          title: this.$t("dashboard.banner"),
          icon: "icon-banner"
        },
        blog: {
          title: this.$t("dashboard.blog"),
          icon: "icon-report"
        },
        faqs: {
          title: this.$t("dashboard.news"),
          icon: "icon-news"
        },
        topIntegrations: {
          title: this.$t("integration.title"),
          icon: "icon-new-intergration"
        },
        changelog: {
          title: this.$t("dashboard.changelog"),
          icon: "icon-changelog"
        },
        quickStartGuide: {
          title: this.$t("dashboard.quickStartGuide"),
          icon: "icon-checklist"
        }
      };
    },
    saveCustomDynamicClass() {
      return [this.saveCustomStatus];
    },
    saveCustomText() {
      switch (this.saveCustomStatus) {
        case "loading":
          return /*html */ `<span class="loader">&nbsp;</span>`;
        case "success":
          return this.$t("generals.success");
        case "error":
          return this.$t("generals.error");
        default:
          return this.$t("dashboard.saveChanges");
      }
    },

    createPageLabel() {
      return {
        landingPages: {
          text: this.$t("page.landingPages1"),
          number: this.$t("dashboard.numberOfLoadingPages")
        },
        homePages: {
          text: this.$t("dashboard.homePage"),
          number: this.$t("dashboard.numberOfHomePages")
        },
        productPages: {
          text: this.$t("dashboard.productPage"),
          number: this.$t("dashboard.numberOfProductPages")
        },
        collectionPages: {
          text: this.$t("dashboard.collectionPage"),
          number: this.$t("dashboard.numberOfCollectionPages")
        },
        articlePages: {
          text: this.$t("dashboard.articlePage"),
          number: this.$t("dashboard.numberOfArticlePages")
        }
      };
    }
  },
  watch: {
    instantShopId: {
      handler: async function() {
        if (this.instantShopId) {
          const res = await getShopMetaByKey(META_KEY_GENERATOR_CONFIG);
          if (res?.data?.shopMetaByKey?.value) {
            this.themeGSConfig = JSON.parse(res?.data?.shopMetaByKey?.value);
            this.isShowPanelThemeChange = this.themeGSConfig?.notificationThemeChange ?? false;
            this.isSessionHasShowPanelThemeChange = this.themeGSConfig?.notificationThemeChange ?? false;
            const themeChange = await getShopifyDefaultTheme();
            this.shopifyDefaultTheme = themeChange.data.shopifyDefaultTheme;
          } else {
            this.isSessionHasShowPanelThemeChange = false;
          }
        }
      },
      immediate: true
    }
  },
  async created() {
    await this.init();
    const themeInf = await getShopifyDefaultTheme();
    if (themeInf.data) {
      this.shopifyDefaultTheme = themeInf.data.shopifyDefaultTheme;
    }

    const res = await getShopMetaByKey(META_KEY_GENERATOR_CONFIG);
    if (res?.data?.shopMetaByKey?.value) {
      this.themeGSConfig = JSON.parse(res?.data?.shopMetaByKey?.value);
      this.isShowPanelThemeChange = this.themeGSConfig?.notificationThemeChange ?? false;
      this.isSessionHasShowPanelThemeChange = this.themeGSConfig?.notificationThemeChange ?? false;
    } else {
      this.isSessionHasShowPanelThemeChange = false;
    }
  },
  methods: {
    ...mapActions("dashboard", {
      putSettings: "putSettings",
      getAllDashboardData: "getAllDashboardData"
    }),
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    ...mapActions("page", {
      createPageWithOneTap: "createPageWithOneTap"
    }),
    ...mapMutations("dashboard", {
      setBFCMBannerClosed: "setBFCMBannerClosed"
    }),
    ...mapMutations("page", {
      setFrameLoading: mutations.SET_FRAME_LOADING
    }),
    closeBFCMBanner() {
      window.localStorage.setItem("bfcmBannerClosedBefore", true);
      this.setBFCMBannerClosed(true)
      this.showBFCMNoticeBanner = false
    },
    closeShowPlanModal() {
      this.$store.commit("account/SHOW_PLAN_MODAL", false);
    },
    redirectToPricing() {
      this.closeShowPlanModal();
      this.$router.push({
        name: "Pricing",
        query: {
          from: this.dynamicTrigger.seasonal_holiday_templates
        }
      });
    },
    async closePanelThemeChange() {
      this.isShowPanelThemeChange = false;
      await shopMetaCreateOrUpdateDocument(META_KEY_GENERATOR_CONFIG, {
        ...this.themeGSConfig,
        notificationThemeChange: false
      });
    },
    trackCreateNewEvent(pageType) {
      let eventId = null;
      let properties = {};

      switch (pageType) {
        case "landing":
          eventId = DASHBOARD_EVENT.CREATE_LANDING_PAGE_CLICKED;
          properties.text = this.createPageLabel.landingPages.text;
          break;
        case "home":
          eventId = DASHBOARD_EVENT.CREATE_HOME_PAGE_CLICKED;
          properties.text = this.createPageLabel.homePages.text;
          break;
        case "product":
          eventId = DASHBOARD_EVENT.CREATE_PRODUCT_PAGE_CLICKED;
          properties.text = this.createPageLabel.productPages.text;
          break;
        case "collection":
          eventId = DASHBOARD_EVENT.CREATE_COLLECTION_PAGE_CLICKED;
          properties.text = this.createPageLabel.collectionPages.text;
          break;
        case "blogpost":
          eventId = DASHBOARD_EVENT.CREATE_BLOG_POST_CLICKED;
          properties.text = this.createPageLabel.articlePages.text;
          break;
      }

      this.trackEvent({ event_id: eventId, properties: properties });
    },

    async init() {
      const shouldHaveLoading = !this.firstCallGetApi;
      await this.getAllDashboardData(shouldHaveLoading);
      const gotItCustomCookie = Cookie.get("GotItCustom");
      if (gotItCustomCookie) {
        const domainArray = JSON.parse(gotItCustomCookie);
        if (domainArray.includes(this.shopifyDomain)) {
          this.showGotItCustom = false;
        } else {
          this.showGotItCustom = true;
        }
      } else {
        this.showGotItCustom = true;
      }
    },
    getComponent(key) {
      return ComponentsMap[key];
    },
    toggleMoreTypes() {
      this.showCreateMoreTypes = !this.showCreateMoreTypes;
    },
    showCustom() {
      if (this.loadingDashboard) return;
      this.resetCustom();
      this.$store.commit("dashboard/TOGGLE_CUSTOM", true);
    },
    resetCustom() {
      this.currentCustomLeftSections = cloneArray(this.leftSections);
      this.currentCustomRightSections = cloneArray(this.rightSections);
      this.saveCustomStatus = "disabled";
    },
    closeCustom() {
      this.currentCustomLeftSections = [];
      this.currentCustomRightSections = [];
      this.saveCustomStatus = "disabled";
      this.$store.commit("dashboard/TOGGLE_CUSTOM", false);
    },
    customItemDynamicClass(item, i) {
      return {
        "mt-1": i > 0,
        "allow-hover": !this.dragging
      };
    },
    startDrag(item, i, e, side = "left") {
      e.preventDefault();
      e.stopPropagation();
      this.dragFrom = { item, i, side };

      let elementRect = null;
      if (side == "left") {
        elementRect = this.$refs.leftItems[i].getBoundingClientRect();
        this.dragList = cloneArray(this.currentCustomLeftSections);
      } else {
        elementRect = this.$refs.rightItems[i].getBoundingClientRect();
        this.dragList = cloneArray(this.currentCustomRightSections);
      }

      const rect = {
        top: elementRect.top,
        left: elementRect.left,
        width: elementRect.width,
        height: elementRect.height,
        clientX: e.clientX,
        clientY: e.clientY
      };

      this.dragRect = rect;
      this.dragging = true;
    },
    dragFunction(event) {
      event.preventDefault();
      if (this.dragging) {
        event = event || window.event;
        let touchLocation = null;
        let moveX = 0;
        let moveY = 0;

        if (event.type === "touchmove") {
          touchLocation = event.targetTouches[0];
          moveX = this.dragRect.clientX - touchLocation.pageX;
          moveY = this.dragRect.clientY - touchLocation.pageY;
        } else {
          moveX = this.dragRect.clientX - event.clientX;
          moveY = this.dragRect.clientY - event.clientY;
        }

        this.dragRect.clientX = event.clientX || touchLocation.pageX;
        this.dragRect.clientY = event.clientY || touchLocation.pageY;

        const currentMinX = this.dragRect.left - moveX;
        const currentMinY = this.dragRect.top - moveY;
        const currentMaxX = currentMinX + this.dragRect.width;
        const currentMaxY = currentMinY + this.dragRect.height;

        const customContainer = this.$refs.customContainer;
        const customContainerRect = customContainer.getBoundingClientRect();
        const containerMinY = customContainerRect.top;
        const containerMaxY = customContainerRect.top + customContainerRect.height;

        const aboveFooter = currentMinY < containerMinY;
        const belowFooter = currentMaxY > containerMaxY;

        if (aboveFooter || belowFooter) {
          const step = 5 * moveY;
          customContainer.scrollTop -= step;
        }

        const checkHtmlIntersect = (element, i) => {
          if (i != this.dragFrom.i) {
            const rect = element.getBoundingClientRect();
            const minX = rect.left;
            const maxX = minX + rect.width;
            const minY = rect.top;
            const maxY = minY + rect.height;

            const aLeftOfB = currentMaxX < minX;
            const aRightOfB = currentMinX > maxX;
            const aAboveB = currentMaxY < minY;
            const aBelowB = currentMinY > maxY;

            const aOutOfB = aLeftOfB || aRightOfB || aAboveB || aBelowB;

            if (!aOutOfB) {
              const item = this.dragList[this.dragFrom.i];
              this.dragList.splice(this.dragFrom.i, 1);
              this.dragList.splice(i, 0, item);
              this.dragFrom.i = i;
            }
          }
        };

        if (this.dragFrom.side == "left") {
          this.$refs.leftItems.forEach(checkHtmlIntersect);
        } else {
          this.$refs.rightItems.forEach(checkHtmlIntersect);
        }

        this.dragRect.left = currentMinX;
        this.dragRect.top = currentMinY;
      }
    },
    finishDrag() {
      if (this.dragging) {
        if (this.dragFrom.side == "left") {
          this.currentCustomLeftSections = cloneArray(this.dragList);
        } else {
          this.currentCustomRightSections = cloneArray(this.dragList);
        }

        this.dragRect = null;
        this.dragging = false;
        this.dragFrom = null;
        this.dragList = [];
        this.checkCustomChange();
      }
    },
    openCreateModal() {
      this.createModalActive = true;
    },

    closeModal() {
      this.createModalActive = false;
    },
    toggleCustomItem(item, e) {
      e.preventDefault();
      e.stopPropagation();

      if (item.disabled) return;

      item.show = !item.show;
      this.checkCustomChange();
    },
    checkCustomChange() {
      const leftCheck = compareArray(this.leftSections, this.currentCustomLeftSections);
      const rightCheck = compareArray(this.rightSections, this.currentCustomRightSections);
      this.saveCustomStatus = leftCheck && rightCheck ? "disabled" : "";
    },
    saveCustomSuccess() {
      this.saveCustomStatus = "success";
      setTimeout(() => {
        this.saveCustomStatus = "";
      }, "1000");
    },
    saveCustomError() {
      this.saveCustomStatus = "error";
      setTimeout(() => {
        this.saveCustomStatus = "";
      }, "1000");
    },
    async clickSaveCustom() {
      if (this.saveCustomStatus != "") return;

      try {
        this.saveCustomStatus = "loading";
        const left = cloneArray(this.currentCustomLeftSections);
        const right = cloneArray(this.currentCustomRightSections);

        await this.putSettings({
          left,
          right
        });

        this.saveCustomSuccess();
        this.closeCustom();
      } catch (err) {
        this.saveCustomError();
      }
    },
    clickGotIt() {
      const gotItCustomCookie = Cookie.get("GotItCustom");
      if (gotItCustomCookie) {
        const domainArray = JSON.parse(gotItCustomCookie);
        if (!domainArray.includes(this.shopifyDomain)) {
          domainArray.push(this.shopifyDomain);
          Cookie.set("GotItCustom", JSON.stringify(domainArray));
        }
      } else {
        const domainArray = [this.shopifyDomain];
        Cookie.set("GotItCustom", JSON.stringify(domainArray));
      }
      this.showGotItCustom = false;
    },
    toggleCreateModal() {
      this.trackEvent({ event_id: DASHBOARD_EVENT.CREATE_NEW_CLICKED, properties: { text: this.createNewTxt } });

      if (this.loadingDashboard) return;
      this.createModalActive = !this.createModalActive;
    },
    closeCreateModal(e) {
      if (e && this.$refs.createModal && this.$refs.createButton && this.createModalActive) {
        const currentX = e.pageX;
        const currentY = e.pageY;
        const createModalRect = this.$refs.createModal.getBoundingClientRect();
        const mouseInCreateModal = currentX >= createModalRect.left && currentX <= createModalRect.left + createModalRect.width && currentY >= createModalRect.top && currentY <= createModalRect.top + createModalRect.height;
        const createButtonRect = this.$refs.createButton.getBoundingClientRect();
        const mouseInCreateButton = currentX >= createButtonRect.left && currentX <= createButtonRect.left + createButtonRect.width && currentY >= createButtonRect.top && currentY <= createButtonRect.top + createButtonRect.height;

        if (!mouseInCreateModal && !mouseInCreateButton) {
          this.createModalActive = false;
        }
      }
    },
    async onCreateNewPage(pageType) {
      if (this.shopInfo.isGemPagesV7) {
        await createThemeAndPageV7(pageType);
        return;
      }

      const { productpages, collectionpages, articlepages } = this.permission;
      let options = null;
      if (pageType === "productpages" && !productpages) {
        options = {
          name: "PricingOnboarding",
          params: {
            id: this.patIdsPricingOnboard.product
          }
        };
      }

      if (pageType === "collectionpages" && !collectionpages) {
        options = {
          name: "PricingOnboarding",
          params: {
            id: this.patIdsPricingOnboard.collection
          }
        };
      }

      if (pageType === "articlepages" && !articlepages) {
        options = {
          name: "PricingOnboarding",
          params: {
            id: this.patIdsPricingOnboard.blog
          }
        };
      }
      if (options) {
        return this.$router.push(options);
      }
      this.createPageWithOneTap({ type: pageType });
      return false;
    }
  }
};
</script>

<style lang="scss">
$padding: 5px;
$dot-faq: 3.75px;

@mixin position-Y-center {
  top: 50%;
  transform: translateY(-50%);
}

.dashboard {
  &__header {
    max-height: 64px;
  }

  &__hello {
    margin-bottom: 6px;
  }

  &__custome {
    &-icon {
      width: 40px;
      height: 40px;
      font-size: 20px;
      background: $light1;

      &:hover {
        background: $textDarkModeHigh;
      }
    }
  }

  &__link {
    color: map-get($primary-blue, "300");

    &-txt {
      margin-right: 8px;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: map-get($primary-blue, "300");
      &:hover {
        text-decoration-line: underline;
        color: map-get($primary-blue, "325");
      }
    }
    &-icon {
      font-size: 16px;
      color: map-get($primary-blue, "300");
    }
  }

  &__create {
    background-color: $mono3;
    position: relative;
    height: 40px;

    &-content {
      height: 100%;
    }

    &-icon {
      font-size: 20px;
    }

    &-txt {
      line-height: 16px !important;
    }

    .dropdown {
      position: absolute;
      top: calc(100%);
      right: 0;
      z-index: 4;
      width: 100%;
      border-radius: 3px;
      @include shadow-hover;

      &__item {
        background-color: $light1;
        cursor: pointer;
        height: 40px;

        &:first-child {
          border-radius: 3px 3px 0 0;
        }

        &:last-child {
          border-radius: 0 0 3px 3px;
        }

        .name {
          color: map-get($dark-text-new, "high-contrast");
        }

        &:hover {
          background-color: map-get($light-grey, "500");
        }
      }
    }

    &:hover {
      background-color: $mono4;
    }

    &.active {
      background-color: $mono4;
    }
  }

  &__placeholder {
    border-radius: 5px;
    height: 72px;
    border: 1px dashed map-get($light-text, "subtext");

    .text {
      &__right {
        max-width: 264px;
      }
    }
  }

  &__template {
    &-btn {
      width: calc(50% - 5px);
    }

    &-overlay {
      position: absolute;
      background: $shade8;
      border-radius: 0px 0px 3px 3px;
      padding: 10.5px 16px;
      margin-top: auto;
      width: 100%;
      bottom: -55px;
      z-index: 1;
      transition-duration: 0.3s;

      .template-item:hover & {
        bottom: 0;
      }

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: $light3;
      }

      .icon {
        font-size: 12px;
        line-height: 12px;
        margin-left: 3px;
      }
    }
  }

  &__link {
    &-icon {
      path {
        fill: map-get($dark-text-new, "low-contrast");
      }
    }

    &:hover {
      color: map-get($primary, "300");

      .dashboard__link {
        &-text {
          color: map-get($primary, "200");
        }

        &-icon {
          path {
            fill: map-get($primary, "200");
          }
        }
      }
    }
  }

  &__faq {
    &-title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      max-height: 3rem;
      width: 100%;
      -webkit-line-clamp: 2;
    }

    &-read {
      color: map-get($dark-text, "disabled");
    }

    &-dot {
      color: map-get($dark-text, "disabled");
      font-size: $dot-faq;
      margin-left: 10.12px;
      margin-right: 10.12px;
    }
  }
}

.section__actions {
  @include trans-all;
  height: 32px;
  background: $light3;
  border-radius: 3px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: $textDarkModeHigh;
  }
}

.custom {
  &.gp_modal-container_body {
    max-height: none;
  }

  &__modal {
    width: 848px;
    position: relative;

    .icon-cancel {
      font-size: 16px;
      color: $textLightModeHigh;
    }
  }

  &__btn {
    background-color: $light2;

    &:hover {
      background-color: map-get($light-grey, "100");
    }
  }

  &__container {
    max-height: calc(100vh - 160px);
    overflow: auto;
  }

  &__tooltip {
    position: relative;

    .content,
    .arrow {
      @include position-Y-center;
      position: absolute;
      display: none;
    }

    &:hover {
      .arrow {
        display: block;
      }

      .content {
        display: flex;
      }
    }

    .content {
      left: calc(100% + 8px);
      width: max-content;
      max-width: 420px;
    }

    .arrow {
      left: calc(100% + 4px);
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-right: 4px solid map-get($dark-blue, "300");
    }
  }

  &__reset {
    border: 1px solid $dark5;
    color: $textLightModeHigh;

    &:hover {
      border-color: $dark7;
      background-color: $textDarkModeHigh;
    }
  }

  &__save {
    color: $light1;
    background-color: $mono3;

    &:hover {
      background-color: $mono4;
    }

    &.disabled {
      color: $textLightModeDisabled;
      background-color: $neutral7;
      cursor: no-drop;
    }

    &.loading {
      .loader {
        border: 4px solid map-get($light-text, "high-contrast");
        border-radius: 50%;
        border-top: 4px solid map-get($dark-text-new, "disabled");
        width: 22px;
        height: 22px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
        display: block;
      }

      /* Safari */
      @-webkit-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
        }
      }

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }

    &.success {
      color: map-get($accent-green-new, "200");
      background-color: map-get($accent-green-new, "500");
    }

    &.error {
      color: map-get($accent-pink, "200");
      background-color: map-get($accent-pink, "500");
    }
  }

  &__col {
    width: calc(50% - 27px);

    &-title {
      letter-spacing: 0.25px;
    }
  }

  &__drag {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    cursor: grabbing;
    border: solid 1px $neutral7;
    border-radius: 3px;

    &-body {
      position: relative;
      width: 100%;
      height: 100%;
      user-select: none;
      background-color: $light2;

      &-content {
        .icon {
          font-size: 20px;
        }
      }
    }

    &-icon {
      position: absolute;
      color: $dark6;
      left: 16px;
      @include position-Y-center;

      .custom__item & {
        display: none;
      }
    }
  }

  &__item {
    cursor: grab;
    position: relative;
    user-select: none;

    &-body {
      background-color: $light2;
      padding: 16px 14px 16px 24px;
      height: 52px;

      &-content {
        .icon {
          font-size: 20px;
        }
      }
    }

    &.allow-hover {
      &:hover {
        .custom__drag-icon {
          display: block;
        }
      }
    }
  }

  &__placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $light6;
  }

  &__switch {
    position: absolute;
    top: 6px;
    right: 14px;
    height: 100%;
    z-index: 1;
    width: 40px;
    height: 40px;
    margin-top: auto;
    margin-bottom: auto;
    top: 0;
    bottom: 0;
    text-align: center;
    justify-content: center;

    &-label {
      width: 4ch;

      &.fr {
        width: 6ch;
      }
    }
  }
}

.slide {
  &__list {
    flex-wrap: nowrap;
    transition-property: transform;
    transition-duration: 1.5s;
    transition-timing-function: cubic-bezier(0, 0.005, 0.39, 1);
  }
}

.custom__modal {
  &-header {
    height: 72px;
    border-bottom: solid 1px $textDarkModeHigh;
  }

  &-footer {
    height: 89px;
    border-top: solid 1px $textDarkModeHigh;
  }

  .gp_modal-close {
    top: 20px !important;
    right: 24px !important;
  }
}

.custom__container {
  .custom__tips {
    .icon-infor-fill {
      font-size: 20px;
      color: $primaryBlue350;
    }

    .icon-cancel {
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.w-dropdown-v6 {
  width: 312px !important;
}
</style>
